import React from 'react';
import './NavBar.scss';
import {connect} from 'react-redux';
import {
    setConsent,
    setPurposeConsent,
    setPurposeLegitimateInterest,
    setObjectConsent,
    setAllConsentSwitch,
    setAllObjectConsentSwitch
} from '../../../../../redux/actions';
import Switch, {SwitchColor} from "../../../../Switch/Switch";
import {allInterests, allPurposes} from "../../../../../scripts/lib/handlers";

const NavBar = props => {
    const changeConsent = async () => {
        let {vendorConsent: newVendorConsent, purposeConsent: newPurposeConsent, vendorList} = props.configuration;
        let consentSwitchValue = allPurposes(props.configuration)

        const consentSwitch = props.setAllConsentSwitch(!consentSwitchValue);

        if (vendorList) {
            vendorList.vendors.forEach(vendor => {
                if (typeof props.configuration.static?.vendorConsent?.[vendor.id] === 'boolean') {
                    newVendorConsent[vendor.id] = props.configuration.static.vendorConsent[vendor.id];
                } else {
                    newVendorConsent[vendor.id] = consentSwitch.payload;
                }
            });
            props.setConsent(newVendorConsent);

            vendorList.purposes.forEach(purpose => {
                if (typeof props.configuration.static?.purposeConsent?.[purpose.id] === 'boolean') {
                    newPurposeConsent[purpose.id] = props.configuration.static.purposeConsent[purpose.id];
                } else {
                    newPurposeConsent[purpose.id] = consentSwitch.payload;
                }
            });
            props.setPurposeConsent(newPurposeConsent);
        }
    }

    const changeObjectConsent = async () => {
        let {
            objectConsent: newObjectConsent,
            purposeLegitimateInterest: newPurposeLegInt,
            vendorList
        } = props.configuration;

        let objectConsentSwitchValue = allInterests(props.configuration);

        const objectConsentSwitch = props.setAllObjectConsentSwitch(!objectConsentSwitchValue);

        if (vendorList) {
            vendorList.vendors.forEach(vendor => {
                if (vendor.legIntPurposes.length) {
                    if (typeof props.configuration.static?.objectConsent?.[vendor.id] === 'boolean') {
                        newObjectConsent[vendor.id] = props.configuration.static.objectConsent[vendor.id];
                    } else {
                        newObjectConsent[vendor.id] = objectConsentSwitch.payload;
                    }
                }
            });
            props.setObjectConsent(newObjectConsent);

            vendorList.purposes.forEach(purpose => {
                if (typeof props.configuration.static?.purposeLegitimateInterest?.[purpose.id] === 'boolean') {
                    newPurposeLegInt[purpose.id] = props.configuration.static.purposeLegitimateInterest[purpose.id];
                } else {
                    newPurposeLegInt[purpose.id] = objectConsentSwitch.payload;
                }
            });
            props.setPurposeLegitimateInterest(newPurposeLegInt);
        }
    }

    let consentSwitchValue = props.consentSwitchValue;
    if (allPurposes(props.configuration)) {
        consentSwitchValue = true;
    }

    let objectConsentSwitchValue = props.objectConsentSwitchValue;
    if (allInterests(props.configuration)) {
        objectConsentSwitchValue = true;
    }

    return (
        <div id="navbar">
            <div id="selectButtons">
                <span className="label">{props.currentLanguage.text.selectAll || '(de)select all:'} </span>
                <Switch label={props.currentLanguage.text.labels.consent || 'Consent'} color={SwitchColor.GREEN}
                        isChecked={consentSwitchValue} changeHandler={() => changeConsent().catch(console.error)}/>
                <Switch label={props.currentLanguage.text.labels.legitimateInterest || 'Legitimate Interest'}
                        color={SwitchColor.ORANGE} changeHandler={() => changeObjectConsent().catch(console.error)}
                        isChecked={objectConsentSwitchValue}/>
            </div>
        </div>
    )
};

const mapStateToProps = state => {
    return {...state};
}

export default connect(mapStateToProps, {
    setConsent,
    setPurposeConsent,
    setPurposeLegitimateInterest,
    setObjectConsent,
    setAllConsentSwitch,
    setAllObjectConsentSwitch
})(NavBar);
